/**
 * Sprite boundaries for the crash rising-tension cue, shared by the player
 * (`Effects.tsx`) and the gain curve (`crashCountdownGain.ts`).
 *
 * They live together because the gain is DERIVED from the build length: the
 * swell has to finish exactly when the build does, so the cue peaks on its own
 * crescendo and then settles as the plateau starts looping. Two copies of
 * these numbers would let the sound and its volume drift apart silently.
 *
 * Boundaries are snapped to points where BOTH CHANNELS sit at a zero crossing
 * simultaneously, found by scanning the decoded stereo waveform.
 *
 * The earlier pass scanned a MONO MIXDOWN, which hides exactly the defect it
 * was looking for: L and R can cancel to ~0 in the sum while each is well away
 * from zero. It picked a splice whose right-channel step was 0.106 — nearly
 * three times the LARGEST natural sample-to-sample change anywhere in the track
 * (0.037) — so the loop still ticked every 3.564s, just quietly enough to be
 * hard to place. These boundaries cut the worst-channel step to 0.0026.
 *
 * Measured against the decoded MP3, which is what every browser actually
 * plays. The .aac twin decodes 23ms later (AAC encoder delay), so a single set
 * of offsets cannot serve both files — which is why the Howl is mp3-only, the
 * same as the main effects sprite sheet.
 */

/** The whole acceleration, played once. */
export const CRASH_COUNTDOWN_BUILD_MS = 13_487.646

/** Where the continuous plateau starts inside the source track. */
export const CRASH_COUNTDOWN_PEAK_START_MS = 9_911.896

/** Length of the looped plateau. */
export const CRASH_COUNTDOWN_PEAK_MS = 3_575.75
